import {
    RESET_SESSION,
    GET_SESSION_LIST,
    GET_SESSION_LIST_SUCCESS,
    GET_SESSION_LIST_ERROR,
    GET_SESSION_DATA,
    GET_SESSION_DATA_SUCCESS,
    GET_SESSION_DATA_ERROR
} from '../constants/ActionTypes';

const INIT_SESSION_STATE = {
    playerUid: "",
    sessionId: "",
    sessionList: [],
    sessionListLoader: false,
    sessionListError: null,
    sessionData: null,
    sessionDataLoader: false,
    sessionDataError: null
}

export default (state = INIT_SESSION_STATE, action) => {
    switch (action.type) {
        case RESET_SESSION: {
            return {
                ...INIT_SESSION_STATE
            }
        }
        case GET_SESSION_LIST: {
            return {
                ...state,
                sessionListLoader: true,
                playerUid: action.payload.playerUid
            }
        }
        case GET_SESSION_LIST_SUCCESS: {
            return {
                ...state,
                sessionList: action.payload,
                sessionListLoader: false,
                sessionListError: null
            }
        }
        case GET_SESSION_LIST_ERROR: {
            return {
                ...state,
                sessionListError: action.payload,
                sessionListLoader: false
            }
        }

        case GET_SESSION_DATA: {
            return {
                ...state,
                sessionId: action.payload.sessionId,
                sessionDataLoader: true
            }
        }
        case GET_SESSION_DATA_SUCCESS: {
            const uid = action.payload !== null ? (action.payload.hasOwnProperty("uid") ? action.payload.uid : "") : ""
            const sesId = action.payload !== null ? (action.payload.hasOwnProperty("id") ? action.payload.id : "") : ""
            if (state.playerUid === uid && state.sessionId === sesId) {
                return {
                    ...state,
                    sessionData: action.payload,
                    sessionDataLoader: false,
                    sessionDataError: null
                }
            } else {
                return {
                    ...state,
                    sessionDataLoader: false,
                    sessionDataError: null
                }
            }
        }
        case GET_SESSION_DATA_ERROR: {
            return {
                ...state,
                sessionDataError: action.payload,
                sessionDataLoader: false
            }
        }
        default:
            return state;
    }
}